import Container from "www/shared/components/container/Container";
import { Button } from "www/shared/components/buttons/Button";
import Image from "next/image";
import heroLogo from "../../../public/marketing/sponsors/hero/hero_logo.png";
import arc from "../../../public/icons/arc.svg";
import { PopupModal } from "react-calendly";
import { useState } from "react";

const SponsorsHero = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  return (
    <section className="flex flex-col items-center justify-center bg-[url('/marketing/sponsors/hero/hero_bg.jpg')] bg-[center_top] bg-cover md:py-32 pt-32 pb-16">
      <Container className="text-center flex flex-col md:flex-row gap-y-3 items-center justify-between">
        <div className="animate-fade-up animate-once animate-duration-[320ms] animate-delay-[75ms] md:animate-delay-[1800ms] animate-ease-in-out animate-normal animate-fill-forwards opacity-0 relative bg-[url('/marketing/sponsors/hero/hero_logo_bg.svg')] flex items-center justify-center min-w-[350px] md:min-w-[370px] md:pb-0 lg:min-w-[480px] xl:min-w-[570px] xl:min-h-[597px] bg-cover bg-left pb-10">
          <div className="min-w-[200px] lg:min-w-[310px] max-w-[250px] md:max-w-[300px] lg:max-w-[350px] xl:max-w-full relative z-10">
            <Image
              src={heroLogo}
              width={390}
              height={430}
              alt="logo"
              priority
            />
          </div>
        </div>
        <div className="flex flex-col items-center md:items-start md:text-left w-full max-w-[420px] lg:max-w-[655px]">
          <span className="text-slate-700 text-sm font-semibold animate-fade-up animate-once animate-duration-[320ms] animate-delay-[320ms] md:animate-delay-0 animate-ease-in-out animate-normal animate-fill-forwards opacity-0">
            For Sponsors
          </span>
          <h2 className="flex flex-col lg:gap-y-3 text-slate-900 text-3xl sm:text-4xl lg:text-6xl font-semibold mt-3">
            <span className="animate-fade-up animate-once animate-duration-[320ms] animate-delay-[640ms] md:animate-delay-[320ms] animate-ease-in-out animate-normal animate-fill-forwards opacity-0">
              What if capital raising
            </span>
            <span className="animate-fade-up animate-once animate-duration-[320ms] animate-delay-[960ms] md:animate-delay-[640ms] animate-ease-in-out animate-normal animate-fill-forwards opacity-0">
              was the{" "}
              <span className="relative">
                easy part?
                <div className="absolute -bottom-2.5 left-0">
                  <Image src={arc} alt="arc" />
                </div>
              </span>{" "}
            </span>
          </h2>
          <p className="text-gray-500 text-sm sm:text-base lg:text-xl font-light mt-6 sm:mt-8 lg:mt-10 animate-fade-up animate-once animate-duration-[320ms] animate-delay-[1280ms] md:animate-delay-[960ms] animate-ease-in-out animate-normal animate-fill-forwards opacity-0">
            With Elmbase, it is. We're here to streamline the fragmented process
            so you can raise more, faster.
          </p>
          <Button
            className="px-5 lg:px-6 bg-[center_top] bg-cover py-3 mt-10 md:mt-8 lg:mt-10 animate-fade-up animate-once animate-duration-[320ms] animate-delay-[1600ms] md:animate-delay-[1280ms] animate-ease-in-out animate-normal animate-fill-forwards opacity-0"
            onClick={() => setIsCalendlyOpen(true)}
          >
            Book a demo
          </Button>
        </div>
      </Container>
      {isCalendlyOpen && (
        <PopupModal
          url="https://calendly.com/ajaysohmshetty"
          pageSettings={{
            hideEventTypeDetails: false,
          }}
          rootElement={document.getElementById("calendly-root") as HTMLElement}
          open={isCalendlyOpen}
          onModalClose={() => setIsCalendlyOpen(false)}
        />
      )}
    </section>
  );
};

export default SponsorsHero;
